import { Pipe, PipeTransform } from '@angular/core';
import { CURRENCY_SYMBOL } from 'sharedweb/helpers/shared-constants';
import { DomSanitizerPipe } from '../dom-sanitizer/dom-sanitizer.pipe';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'formatNumber'
})
export class FormatNumberPipe implements PipeTransform {

  constructor(private sanitized?: DomSanitizer) { }
  /**
   * Pipe to format numbers based in input parameters
   * @param value The value to be formatted
   * @param commas If commas are desired (Indian number system)
   * @param currency If Rs. symbol is desired
   * @param precision If numbers has to be shown with precision.
   */
  transform(value: any, commas?: boolean, currency?: boolean, precision?: number, convertLocale?: boolean, twoPrecision?: boolean, applyFontSize?: boolean): unknown {
    if (isNaN(value)) {
      /** 
       * let a ;
       * let b;
       * let c = a + b;
       * console.log('a', a)----> undefined
       * console.log("c", c)----> NaN
       * console.log("c.toString()", c.toString())----> 'NaN'
       * console.log("typeof c", typeof c)----> number
       * If value is a string 'NaN' or undefined, return '--'.
       */
      
      if (value === undefined || value.toString() === 'NaN') {
        return '--';
      }
      return value;
    }

    if (value === null) {
      return '--';
    }

    value = +value;
    const isNeg = (value < 0);

    if (isNeg) {
      value = -1 * value;
    }

    let suffix = '';
    let decimal = '';
    if (convertLocale) {
      if (value >= 1e7) {
        value = value / 1e7;
        suffix = ' Cr';
      } else if (value >= 1e5) {
        value = value / 1e5;
        suffix = ' L';
      } else if (value >= 1e3) {
        value = value / 1e3;
        suffix = ' K';
      }
    }

    value = value.toFixed(precision ? precision : 0);

    if (commas) {
      if (value != 0) {
        // After precision has been added, we want to add commas just to the whole part of the number
        const wholePart = value.toString().split('.')[0];
        if (precision) {
          decimal = `.${value.toString().split('.')[1] || '00'}`;
          if (twoPrecision) {
            decimal.length == 2 ? decimal = decimal + '0' : '';
          }
          value = `${value.toString().split('.')[0]}`;
        }
        let lastThree = '';
        if (wholePart.toString().length > 3) {
          // Separating last 3 digits.
          lastThree = ',' + wholePart.toString().slice(-3);
          // Number left after separating last 3 digits
          value = wholePart.toString().slice(0, -3);
          // Formatting the value to be comma separated at every 2nd index + last 3 digits 
          value = value.toString().replace(/\B(?=(\d{2})+(?!\d))/g, ',') + `${lastThree}`;
        }
      }
    }

    if (applyFontSize) {
      if (value === 0) {
        return this.sanitized.bypassSecurityTrustHtml(`<span class="num-integer">${isNeg ? '-' : ''}${currency ? CURRENCY_SYMBOL : ''}${'0'}</span><span class="num-fractional">${'.00'}</span>`);
      }
      return this.sanitized.bypassSecurityTrustHtml(`<span class="num-integer">${isNeg ? '-' : ''}${currency ? CURRENCY_SYMBOL : ''}${value}</span><span class="num-fractional">${decimal}${suffix ? suffix : ''}</span>`);
    }
    if (currency) {
      // Adding Rs symbol
      value = `${CURRENCY_SYMBOL}${value}${decimal}`;
    }
    if (!currency && !applyFontSize) {
      value = `${value}${decimal}`;
    }

    return (isNeg ? '-' : '') + value + `${suffix}`;
  }

}
